"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapColumnToSelectItems = void 0;
function mapColumnToSelectItems(fields) {
    const items = [{ value: null, label: 'Select source field' }];
    for (const fieldName of fields) {
        if (fieldName) {
            items.push({ value: fieldName, label: fieldName });
        }
    }
    return items;
}
exports.mapColumnToSelectItems = mapColumnToSelectItems;
